<div class="col-size6 t-col-size8 m-col-size4">
  <div class="title">
    {{ 'PROFILE.PRIVACY_POLICY.TREATMENT_TITLE' | translate }}
  </div>
  <span class="subtitle">{{
    'PROFILE.PRIVACY_POLICY.TREATMENT_SUBTITLE' | translate
  }}</span>
  <div class="title">
    {{ 'PROFILE.PRIVACY_POLICY.TREATMENT_PURPOSE_TITLE' | translate }}
  </div>
  <span class="subtitle">{{
    'PROFILE.PRIVACY_POLICY.TREATMENT_PURPOSE_SUBTITLE' | translate
  }}</span>
  <div class="title">
    {{ 'PROFILE.PRIVACY_POLICY.RIGHTS_TITLE' | translate }}
  </div>
  <span class="subtitle">{{
    (auth.checkUserIsParticular()
    ? 'PROFILE.PRIVACY_POLICY.RIGHTS_SUBTITLE'
    : 'PROFILE.PRIVACY_POLICY.ACI_RIGHTS_SUBTITLE') | translate
  }}</span>
  <div class="mapfre-mt-xsm" *ngIf="auth.checkUserIsParticular()">
    <a href="{{ policy }}" target="_blank">
      {{ 'PROFILE.PRIVACY_POLICY.POLICY_LINK' | translate }}
    </a>
  </div>
</div>
